import { UserContact } from "@Interfaces/interfaces";
import { createAction, props } from "@ngrx/store";


export const loadContacts = createAction(
  '[CONTACTS] Load contacts',
  props<{ delayTime: number}>()
)

export const setContacts = createAction(
  '[CONTACTS] Saving contacts',
  props<{ contacts: UserContact[] }>()
)

export const contactsLoadError = createAction(
  '[ERROR][CONTACTS] Error while loading contacts'
)

export const contactsDoneLoading = createAction(
  '[CONTACTS] Done loading contacts'
)

export const clearContactsState = createAction(
  '[CONTACTS] Clear contacts state'
)
